import {
  createElement,
  forwardRef,
  type ComponentPropsWithoutRef,
  type ElementType,
  type ReactNode,
} from "react";

// The marketing pages only use Framer Motion for decorative entrance effects.
// Rendering the same semantic elements directly removes a large runtime and,
// importantly, prevents above-the-fold copy from waiting on JavaScript-driven
// opacity animations before it can become the Largest Contentful Paint.
const MOTION_ONLY_PROPS = new Set([
  "animate",
  "drag",
  "dragConstraints",
  "exit",
  "initial",
  "layout",
  "layoutId",
  "transition",
  "variants",
  "viewport",
  "whileFocus",
  "whileHover",
  "whileInView",
  "whileTap",
]);

type MotionProps = Record<string, unknown> & { children?: ReactNode };

const createMotionElement = (tag: ElementType) =>
  forwardRef<HTMLElement, MotionProps>(({ children, ...props }, ref) => {
    const domProps = Object.fromEntries(
      Object.entries(props).filter(([name]) => !MOTION_ONLY_PROPS.has(name)),
    ) as ComponentPropsWithoutRef<ElementType>;

    return createElement(tag, { ...domProps, ref }, children);
  });

export const motion = new Proxy({} as Record<string, ReturnType<typeof createMotionElement>>, {
  get(target, tag: string) {
    target[tag] ??= createMotionElement(tag);
    return target[tag];
  },
});

export const AnimatePresence = ({ children }: { children?: ReactNode }) => children;

export const useReducedMotion = () => true;
